<cudc-ea-authenticate
  *ngIf="showWidget"
  class="bl-display--block bl-margin-x--auto"
  [widgetContext]="widgetContext"
  (widgetExportDataChange)="receivedDataHandler($event)"
  (widgetInfoStateChange)="receivedStateInfoHandler($event)"
></cudc-ea-authenticate>
<div
  class="bl-width--100 bl-max-width--tablet-width bl-margin-left--auto bl-margin-right--auto bl-block-module bl-padding--24"
  *ngIf="showError"
>
  <ea-alert
    *ngIf="!showCloseable; else closeableAlert"
    alertId="send-code-alert"
    alertStatus="error"
    [heading]="showRetry ? ('arcdx-verify/error/canRetry/heading' | dictionary) : ('arcdx-verify/error/canNotRetry/heading' | dictionary)"
    [message]="showRetry ? ('arcdx-verify/error/canRetry/message' | dictionary) : ('arcdx-verify/error/canNotRetry/message' | dictionary)"
    [showAlert]="showError"
  ></ea-alert>

  <ng-template #closeableAlert>
    <ea-alert
      *ngIf="showError"
      alertId="send-code-alert"
      alertStatus="error"
      [heading]="'arcdx-verify/error/invalidNumber/heading' | dictionary"
      [message]="'arcdx-verify/error/invalidNumber/message' | dictionary"
      [showAlert]="showError"
      (closeEvent)="closeAlert()"
    ></ea-alert>
  </ng-template>
  <div *ngIf="showRetry" class="bl-margin-top--16 bl-text-align--right">
    <ea-button-loader
      buttonType="button"
      buttonId="verify-btn-retry"
      [loading]="loading"
      text="Resend Code"
      (event)="retry()"
      buttonClass="bl-margin-left--auto"
    ></ea-button-loader>
  </div>
</div>
